import { useCallback, useEffect, useState } from "react";
import { useGlitch } from "react-powerglitch";

const GLITCH_DURATION_MS = 700;
const GLITCH_CLEANUP_MS = GLITCH_DURATION_MS + 50;
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

const IntroOverlay = () => {
  const [visible, setVisible] = useState(true);
  const reducedMotion = typeof window !== "undefined"
    && typeof window.matchMedia === "function"
    && window.matchMedia(REDUCED_MOTION_QUERY).matches;
  const { ref, startGlitch, stopGlitch } = useGlitch({
    playMode: "click",
    optimizeSeo: true,
    createContainers: false,
    hideOverflow: true,
    timing: { duration: GLITCH_DURATION_MS, iterations: 1 },
    glitchTimeSpan: { start: 0.08, end: 0.92 },
    shake: { velocity: 18, amplitudeX: 0.1, amplitudeY: 0.05 },
    slice: { count: 10, velocity: 18, minHeight: 0.02, maxHeight: 0.04, hueRotate: false },
  });
  const attachGlitch = useCallback((element: HTMLDivElement | null) => {
    if (!element || element.dataset.glitchAttached) return;
    element.dataset.glitchAttached = "true";
    ref(element);
  }, [ref]);

  useEffect(() => {
    if (reducedMotion) return;
    startGlitch();
    const cleanupTimer = window.setTimeout(() => {
      stopGlitch();
      setVisible(false);
    }, GLITCH_CLEANUP_MS);
    return () => {
      window.clearTimeout(cleanupTimer);
      stopGlitch();
    };
  }, [reducedMotion, startGlitch, stopGlitch]);

  if (!visible || reducedMotion) return null;

  return (
    <div className="landing-glitch" aria-hidden="true">
      <div ref={attachGlitch} className="landing-glitch-layers">
        <div className="landing-glitch-art" />
      </div>
    </div>
  );
};

export default IntroOverlay;
